import { Tooltip, Link } from "@mui/material";
import {
  getFileNameFromUrl,
  multiplierMappings,
  multiplierOptions,
} from "../../../utils";
import CustomEditComponent from "./CustomEditComponent";
import config from "../../../config";

export const getDiscountColumns = (processCallback) => [
  {
    field: "fl_dept_name",
    headerName: "Department",
    flex: 1.5,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_class_name",
    headerName: "Category",
    flex: 1.5,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_sub_name",
    headerName: "Planogram",
    flex: 1.5,
    renderCell: (params) => (
      <Tooltip
        title={
          params.row.region
            ? `${params.value} - Region: ${params.row.region}`
            : params.value
        }
      >
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "planogram",
    headerName: "Planogram #",
    flex: 1.25,
    renderCell: (params) => (
      <Tooltip title={params.value ? getFileNameFromUrl(params.value) : ""}>
        <Link
          href={config.PogFileBasePath.concat(params.value)}
          target="_blank"
          rel="noreferrer noopener"
        >
          {getFileNameFromUrl(params.value)}
        </Link>
      </Tooltip>
    ),
  },
  {
    field: "footage",
    headerName: "Footage",
    flex: 1,
  },
  {
    field: "discMultiplier",
    headerName: "Discount Multiplier",
    width: 85,

    sortable: false,
    renderCell: (params) => {
      return params?.isEditable
        ? params?.value
          ? multiplierMappings[params?.value]
          : "-"
        : "";
    },
    renderEditCell: (params) => (
      <CustomEditComponent
        {...params}
        getProcessedRow={processCallback}
        fieldType="multiplier"
        default=""
        options={multiplierOptions}
      />
    ),
    editable: true,
  },
  {
    field: "CoreDiscountPercent",
    headerName: "Core %",
    sortable: false,
    flex: 0.75,
    disableClickEventBubbling: true,
    renderCell: (params) => {
      return params?.isEditable ? params.value : "";
    },
    renderEditCell: (params) => {
      return (
        <CustomEditComponent
          {...params}
          getProcessedRow={processCallback}
          fieldType="number"
        />
      );
    },
    editable: true,
  },
  {
    field: "NonCoreDiscountPercent",
    headerName: "Non Core %",
    sortable: false,
    flex: 1,
    renderCell: (params) => {
      return params?.isEditable ? params.value : "";
    },
    renderEditCell: (params) => {
      return (
        <CustomEditComponent
          {...params}
          getProcessedRow={processCallback}
          fieldType="number"
        />
      );
    },
    editable: true,
  },
  {
    field: "DatingDays",
    headerName: "Dating Days",
    sortable: false,
    flex: 1,
    renderCell: (params) => {
      return params?.isEditable ? params.value : "";
    },
    renderEditCell: (params) => (
      <CustomEditComponent
        {...params}
        getProcessedRow={processCallback}
        fieldType="days"
      />
    ),
    editable: true,
  },
];

export const DISCOUNT_EDITABLE_FIELDS = getDiscountColumns()
  .map((c) => c.editable && c.field)
  .filter((i) => !!i);
